import keyMirror from "keymirror";

const XES_START_SAVING = 'xes/scratch-gui/project/XES_START_SAVING';
const XES_START_SHARING = 'xes/scratch-gui/project/XES_START_SHARE';
const XES_START_SUBMITING = 'xes/scratch-gui/project/XES_START_SUBMIT';
const XES_START_CHECKING = 'xes/scratch-gui/project/XES_START_CHECK';
const XES_START_CHECKING_BACKGROUND = 'xes/scratch-gui/project/XES_START_CHECKING_BACKGROUND';

const XES_START_PUBLISHING = 'xes/scratch-gui/project/XES_START_PUBLISH';
const XES_START_INITING = 'xes/scratch-gui/project/XES_START_INITING'
const XES_CONFIRM_PUBLISHING = 'xes/scratch-gui/project/XES_START_PUBLISH';
const XES_UPLOAD_FINISH = 'xes/scratch-gui/project/XES_UPLOAD_FINISH';

const XES_DONE_SAVE = 'xes/scratch-gui/project/XES_DONE_SAVING';
const XES_DONE_LOADED = 'xes/scratch-gui/project/XES_DONE_LOADED';
const XES_RESET_LOADING_STATE = 'xes/scratch-gui/project/XES_RESET_LOADING_STATE'

const XES_SET_PROJECT_ID = 'xes/scratch-gui/project/XES_SET_PROJECT_ID'
const XES_SET_PROJECT_META = 'xes/scratch-gui/project/XES_SET_PROJECT_META'
const XES_RESET_PROJECT_META = 'xes/scratch-gui/project/XES_RESET_PROJECT_META'

const XesLoadingState = keyMirror({
    XES_SAVING: null,
    XES_SAVING_AS: null,
    XES_SHARING: null,
    XES_SUBMITING: null,
    XES_CHECKING: null,
    XES_CHECKING_BACKGROUND: null,
    XES_UPLOAD_DONE: null,
    XES_SAVE_DONE: null,
    XES_RESET: null,
    XES_PUBLISHING: null,
    XES_INITING: null,
    XES_DONE_LOADED: null
})
const initialState = {
    XesLoadingState: null,
    xesProjectId: null,
    xesProjectMeta: null,
    isLoaded: false
}
const getIsSaving = (loadingState) => {
    return loadingState === XesLoadingState.XES_SAVING
}
const reducer = (state, action) => {
    if (typeof state === 'undefined') state = null

    switch (action.type) {
        case XES_START_SAVING:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_SAVING
            });
        case XES_START_SUBMITING:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_SUBMITING
            });
        case XES_DONE_LOADED:
            return Object.assign({}, state, {
                isLoaded: true
            });
        case XES_UPLOAD_FINISH:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_UPLOAD_DONE
            });
        case XES_START_CHECKING:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_CHECKING
            });
        case XES_START_CHECKING_BACKGROUND:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_CHECKING_BACKGROUND,
                xesBackgroundCheckType: action.xesBackgroundCheckType
            });
        case XES_START_SHARING:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_SHARING
            });
        case XES_START_INITING:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_INITING
            });
        case XES_CONFIRM_PUBLISHING:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_PUBLISHING
            });
        case XES_DONE_SAVE:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_SAVE_DONE
            });
        case XES_RESET_LOADING_STATE:
            return Object.assign({}, state, {
                xesLoadingState: XesLoadingState.XES_RESET
            });
        case XES_SET_PROJECT_ID:
            return Object.assign({}, state, {
                xesProjectId: action.xesProjectId
            })
        case XES_SET_PROJECT_META:
            return Object.assign({}, state, {
                xesProjectMeta: action.xesProjectMeta
            })
        case XES_RESET_PROJECT_META:
            return Object.assign({}, state, {
                xesProjectMeta: {
                    id: null
                }
            })
        default:
            return state;
    }
}

const onXESSave = () => ({
    type: XES_START_SAVING
})
const onXESShare = () => ({
    type: XES_START_SHARING
})
const onXESCheck = () => ({
    type: XES_START_CHECKING
})
const onXESPublish = () => ({
    type: XES_START_PUBLISHING
})
const onXESUploadDone = () => ({
    type: XES_UPLOAD_FINISH
})
const onXESInit = () => ({
    type: XES_START_INITING
})
const onXESConfirmPublish = () => ({
    type: XES_CONFIRM_PUBLISHING
})
const onXESConfirmSubmit = () => ({
    type: XES_START_SUBMITING
})
const resetLoadingState = () => ({
    type: XES_RESET_LOADING_STATE
})
const setXesProjectId = (xesProjectId) => ({
    type: XES_SET_PROJECT_ID,
    xesProjectId
})
const setXesProjectMeta = (xesProjectMeta) => ({
    type: XES_SET_PROJECT_META,
    xesProjectMeta
})
const resetXesProjectMeta = () => ({
    type: XES_RESET_PROJECT_META
})
const onXESLoadDone = () => ({
    type: XES_DONE_LOADED
})
const onXESCheckBackGround = (xesBackgroundCheckType) => ({
    type: XES_START_CHECKING_BACKGROUND,
    xesBackgroundCheckType
})
export {
    reducer as
    default,
    initialState as xesProjectInitialState,
    onXESSave,
    onXESCheck,
    onXESInit,
    getIsSaving,
    XesLoadingState,
    resetLoadingState,
    onXESShare,
    onXESPublish,
    setXesProjectId,
    setXesProjectMeta,
    resetXesProjectMeta,
    onXESConfirmPublish,
    onXESConfirmSubmit,
    onXESUploadDone,
    onXESLoadDone,
    onXESCheckBackGround
}